import { useContext, useEffect } from 'react'
import useProgressiveDataLoader from './useProgressiveDataLoader'
import {
  GET_INCIDENT_ACK_TIME_KPI_SETTINGS_LOOKUP_QUERY
} from "../constants/queries/lookup";
import  GlobalContext  from '../providers/GlobalContext'


function useIncidentAckTimeKpiSettingsLookupData() {

  const { fetchData: fetchKpiSettingsData, data: kpiSettingsLookupData } = useProgressiveDataLoader({query: GET_INCIDENT_ACK_TIME_KPI_SETTINGS_LOOKUP_QUERY });

  const { selectedCompany } = useContext(GlobalContext);

  useEffect(()=>{
    if (selectedCompany && selectedCompany.id){
      fetchKpiSettingsData({
        variables: {
          companyId: selectedCompany.id,
          page: 1
        }
      });
    }
    // eslint-disable-next-line
  }, [selectedCompany]);


  return {
    kpiSettingsLookupData
  }

}



export default useIncidentAckTimeKpiSettingsLookupData;
